import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0D110D] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-lg"
      >
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-4">
          Pagamento Annullato
        </p>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#E8E2D2] mb-6 leading-none">
          Nessun <span className="italic">problema</span>
        </h1>
        <p className="text-[#E8E2D2]/60 mb-10">
          Il tuo carrello è ancora qui ad aspettarti. Completa l'ordine quando vuoi.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#D47738] text-[#0D110D] px-10 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors duration-300"
          data-testid="cancel-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna al Carrello
        </Link>
      </motion.div>
    </div>
  );
}
